/*
  «Мій профіль» (sections/profile.liquid).

  Reads the config Liquid printed (the signed token and every string), asks the
  Edge Function `profile` once, and hands each panel on the page its key of the
  answer. A panel is registered below with panel('<block type>', draw); draw(body,
  data, api) fills the panel's body and may call api.call({...}) to change
  something, then redraw from the answer — so the page never shows a value the
  database does not hold.

  Panels: ambassador (the former /pages/ambassador-cabinet), tickets and badges
  (the collection; its canvas art and holographic tilt are window.GalasBadges,
  assets/profile-badges.js). The newsletter panel is plain Liquid and Shopify's
  own form; it needs no script.
*/
(function () {
  var configEl = document.querySelector('[data-profile-config]');
  var root = document.querySelector('[data-profile]');
  if (!configEl || !root) return;

  var cfg = JSON.parse(configEl.textContent);
  if (!cfg.auth) return;
  var T = cfg.t;
  var locale = { uk: 'uk-UA', en: 'en-GB', pl: 'pl-PL' }[cfg.locale] || 'uk-UA';

  /* ── helpers ────────────────────────────────────────────────────────── */
  function el(tag, props, children) {
    var node = document.createElement(tag);
    Object.keys(props || {}).forEach(function (key) {
      var value = props[key];
      if (value == null || value === false) return;
      if (key === 'class') node.className = value;
      else if (key === 'text') node.textContent = value;
      else if (key === 'html') node.innerHTML = value;
      else if (key.slice(0, 2) === 'on') node.addEventListener(key.slice(2), value);
      else node.setAttribute(key, value === true ? '' : value);
    });
    (Array.isArray(children) ? children : children == null ? [] : [children]).forEach(function (child) {
      if (child == null || child === false) return;
      node.appendChild(typeof child === 'string' ? document.createTextNode(child) : child);
    });
    return node;
  }
  function fill(template, values) {
    return String(template).replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
      return values[key] == null ? '' : values[key];
    });
  }
  function date(iso, options) {
    if (!iso) return '';
    // dd.mm.yyyy everywhere: short, the same in three languages, never breaks a line.
    return new Intl.DateTimeFormat(locale, options || NUMERIC_DATE).format(new Date(iso));
  }
  var NUMERIC_DATE = { day: '2-digit', month: '2-digit', year: 'numeric' };
  function clear(node) { while (node.firstChild) node.removeChild(node.firstChild); }
  function button(label, props) {
    return el('button', Object.assign({ type: 'button', class: 'button button--primary' }, props || {}),
      el('span', { class: 'button__label', text: label }));
  }

  var ICON = {
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>',
    clock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"></circle><polyline points="12 7 12 12 15 14"></polyline></svg>',
    dot: '<svg viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="12" r="4"></circle></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="11" width="14" height="10" rx="2"></rect><path d="M8 11V7a4 4 0 0 1 8 0v4"></path></svg>',
    sparkle: '<svg viewBox="0 0 24 24" class="icon-sparkle"><path d="M12 2.5c.7 5.2 4.3 8.8 9.5 9.5-5.2.7-8.8 4.3-9.5 9.5-.7-5.2-4.3-8.8-9.5-9.5 5.2-.7 8.8-4.3 9.5-9.5z"></path></svg>',
    qr: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"></rect><rect x="14" y="3" width="7" height="7" rx="1"></rect><rect x="3" y="14" width="7" height="7" rx="1"></rect><path d="M14 14h3v3h-3zM20 14v.01M14 20h.01M17 20h4v-3"></path></svg>',
    doc: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z"></path><polyline points="14 3 14 8 19 8"></polyline></svg>',
    wallet: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="6" width="18" height="14" rx="2"></rect><path d="M3 10h18M16 15h2"></path></svg>'
  };

  var toast;
  function flash(text, bad) {
    if (!toast) {
      toast = el('p', { class: 'amb-cab__toast', role: 'status' });
      document.body.appendChild(toast);
    }
    toast.textContent = text;
    toast.classList.toggle('is-bad', Boolean(bad));
    toast.classList.add('is-on');
    clearTimeout(flash.t);
    flash.t = setTimeout(function () { toast.classList.remove('is-on'); }, 2600);
  }

  function call(extra) {
    return fetch(cfg.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(Object.assign({ locale: cfg.locale }, cfg.auth, extra || {}))
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) { var error = new Error(data.error || String(res.status)); error.code = data.error; throw error; }
        return data;
      });
    });
  }

  var api = { call: call, flash: flash, el: el, fill: fill, date: date, clear: clear, T: T, cfg: cfg, icon: ICON };
  var panels = {};
  var pickers = {};
  // `pick` chooses what the panel is handed; by default its own key of the answer.
  function panel(type, draw, pick) { panels[type] = draw; if (pick) pickers[type] = pick; }

  /* ── Твій Галас: a few figures beside the tier card ──────────────────── */
  // Badges held of all there are, Galas editions attended, partner events,
  // months with the programme. Only what is true and non-zero is said; at most four.
  var answer = null;
  function statsCard(a) {
    if (!cfg.badges) return null;
    var all = badgeModel(answer);
    var held = all.filter(function (b) { return b.state !== 'locked'; });
    var open = held.filter(function (b) { return b.state === 'open'; });
    var figures = [
      { n: held.length, of: all.length, label: T.stats_badges },
      { n: open.filter(function (b) { return b.group !== 'partner'; }).length, label: T.stats_galas },
      { n: open.filter(function (b) { return b.group === 'partner'; }).length, label: T.stats_partner }
    ];
    if (a && a.found) {
      // ambassador_cabinet counts the months itself; the start date is the fallback.
      var months = Number(a.months);
      if (!months && a.started_at) {
        var start = new Date(a.started_at);
        var now = new Date();
        months = (now.getFullYear() - start.getFullYear()) * 12 + now.getMonth() - start.getMonth() + 1;
      }
      if (months > 0) figures.push({ n: months, label: T.stats_months });
    }
    figures = figures.filter(function (f, i) { return i === 0 || f.n > 0; });

    // The whole collection in miniature: held in colour, the rest as outlines.
    var shelf = el('ul', { class: 'profile-stats__shelf', role: 'list', 'aria-hidden': 'true' }, all.map(function (b) {
      return el('li', { class: 'profile-stats__mini profile-stats__mini--' + b.state, title: b.title },
        face(b, b.state === 'locked' ? 'outline' : 'colour'));
    }));

    // The next event this person holds a ticket for, if any.
    var today = new Date().toISOString().slice(0, 10);
    var next = held.filter(function (b) { return b.state === 'open' && String(b.end || b.start) >= today; })
      .sort(function (x, y) { return String(x.start).localeCompare(String(y.start)); })[0];

    return el('article', { class: 'amb-cab__card profile-stats' }, [
      el('h3', { class: 'profile-stats__title', text: T.stats_title }),
      shelf,
      el('dl', { class: 'profile-stats__list' }, figures.map(function (f) {
        return el('div', { class: 'profile-stats__item' }, [
          el('dt', { class: 'profile-stats__label', text: f.label }),
          el('dd', { class: 'profile-stats__value' }, [
            String(f.n),
            f.of ? el('span', { class: 'profile-stats__of', text: '/' + f.of }) : null
          ])
        ]);
      })),
      next ? el('p', { class: 'profile-stats__next' }, [
        el('span', { class: 'profile-stats__next-mark', 'aria-hidden': 'true', html: ICON.sparkle }),
        el('span', { class: 'profile-stats__next-label', text: T.stats_next }),
        el('span', { class: 'profile-stats__next-what', text: next.title + ' · ' + days(next.start, next.end) })
      ]) : null,
      el('a', { class: 'profile-stats__link', href: cfg.galleryUrl, text: T.badges_see_all })
    ]);
  }

  /* ── Амбасадор ──────────────────────────────────────────────────────── */
  panel('ambassador', function draw(body, a) {
    clear(body);
    if (!a || !a.found) {
      body.appendChild(el('div', { class: 'amb-cab__card profile-empty' }, [
        el('span', { class: 'amb-cab__gate-mark', 'aria-hidden': 'true', html: ICON.sparkle }),
        el('div', { class: 'profile-empty__text' }, [
          el('h3', { class: 'amb-cab__h3', text: T.none_title }),
          el('p', { class: 'amb-cab__muted', text: T.none_body })
        ]),
        el('a', { class: 'button button--cta', href: cfg.tiersUrl }, el('span', { class: 'button__label', text: T.none_cta }))
      ]));
      var figures = statsCard(null);
      if (figures) body.appendChild(figures);
      return;
    }

    function redraw(data) { draw(body, data.ambassador); }
    var tier = Math.max(0, Math.min(3, Number(a.tier) || 0));

    function statusChip() {
      var kind = a.active ? 'ok' : (a.cancelled_at ? 'off' : 'warn');
      var text = a.active ? T.status_active : (a.cancelled_at ? T.status_cancelled : T.status_lapsed);
      return el('span', { class: 'amb-cab__chip amb-cab__chip--' + kind, text: text });
    }

    function tierCard() {
      // One date only. A return after cancelling is a second first payment: then
      // the card counts from the return and says so.
      var firsts = (a.payments || []).filter(function (p) { return p.kind !== 'renewal' && !p.refunded; })
        .map(function (p) { return p.paid_at; }).sort();
      var back = firsts.length > 1;
      var card = el('article', { class: 'amb-cab__card amb-cab__tier amb-cab__tier--' + tier }, [
        // The foil (ambassador-cabinet.css), steered by GalasBadges.holo.
        el('span', { class: 'tier-holo', 'aria-hidden': 'true' }, [
          el('span', { class: 'tier-holo__wash' }),
          el('span', { class: 'tier-holo__cloth' }, el('span', { class: 'tier-holo__band' })),
          el('span', { class: 'tier-holo__glare' })
        ]),
        el('div', { class: 'amb-cab__tier-head' }, [
          el('p', { class: 'amb-cab__eyebrow', text: tier ? fill(T.level, { n: tier }) : '' }),
          statusChip()
        ]),
        el('h3', { class: 'amb-cab__tier-name', text: T.tier_names[tier] }),
        el('p', { class: 'amb-cab__tier-price' }, [
          el('span', { class: 'amb-cab__tier-amount', text: String(Math.round(Number(a.amount))) }),
          el('span', { class: 'amb-cab__tier-unit', text: cfg.currency + T.per_month })
        ]),
        el('p', { class: 'amb-cab__since' }, [
          el('span', { text: back ? T.back_since : T.since }),
          el('span', { class: 'amb-cab__since-date', text: date(back ? firsts[firsts.length - 1] : a.started_at) })
        ]),
        a.active ? null : el('p', { class: 'amb-cab__note', text: T.lapsed_note })
      ]);
      // Shown by holo() only where the browser asks before giving the tilt (iOS).
      var ask = el('button', { type: 'button', class: 'amb-cab__tilt', hidden: true }, [
        el('span', { 'aria-hidden': 'true', html: ICON.sparkle }),
        el('span', { text: T.tilt_ask })
      ]);
      if (window.GalasBadges) window.GalasBadges.holo(card, { tilt: 7, gyro: true, ask: ask });
      return [card, ask];
    }

    function inlineForm(opts) {
      var input = el('input', Object.assign({
        id: opts.id, class: 'amb-tg__input', type: 'text', autocomplete: 'off', value: opts.value || '',
        'aria-describedby': opts.id + '-hint'
      }, opts.input));
      var save = el('button', { type: 'submit', class: 'button button--primary amb-cab__save' }, el('span', { class: 'button__label', text: T.tg_save }));
      var form = el('form', { class: 'amb-cab__tg-form', novalidate: true }, [
        el('label', { class: 'amb-tg__label', for: opts.id, text: opts.label }),
        el('div', { class: 'amb-cab__tg-row' }, [input, save]),
        el('p', { id: opts.id + '-hint', class: 'amb-tg__hint', text: opts.hint })
      ]);
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var value = opts.read(input);
        if (value === null) { input.reportValidity(); input.focus(); return; }
        save.disabled = true;
        call(Object.assign({ action: 'ambassador' }, opts.payload(value))).then(function (data) {
          redraw(data);
          flash(opts.saved);
        }, function (error) {
          save.disabled = false;
          if (error.code === opts.errorCode) { input.setCustomValidity(opts.error); input.reportValidity(); }
          else flash(T.save_failed, true);
        });
      });
      return form;
    }

    function detailsCard() {
      var tgState = a.telegram_invited_at ? 'done' : (a.telegram ? 'waiting' : 'needs');
      var tg = inlineForm({
        id: 'profile-telegram', label: T.tg_label, value: a.telegram, saved: T.tg_saved, errorCode: 'telegram', error: T.tg_error,
        hint: !a.telegram ? T.tg_hint_empty : (a.telegram_invited_at ? T.tg_hint_in : T.tg_hint_waiting),
        input: { maxlength: '64', autocapitalize: 'off', spellcheck: 'false', placeholder: T.tg_placeholder, 'data-error': T.tg_error },
        read: function (input) {
          var r = window.GalasTelegram ? window.GalasTelegram.read(input) : { ok: true, value: input.value.trim() };
          return r.ok ? r.value : null;
        },
        payload: function (value) { return { telegram: value }; }
      });
      var name = inlineForm({
        id: 'profile-name', label: T.name_title, value: a.name, saved: T.name_saved, errorCode: 'name', error: T.save_failed,
        hint: T.name_hint, input: { maxlength: '80', autocomplete: 'given-name', required: true },
        read: function (input) {
          var v = input.value.trim();
          input.setCustomValidity(v ? '' : T.name_hint);
          return v || null;
        },
        payload: function (value) { return { name: value }; }
      });
      return el('article', { class: 'amb-cab__card amb-cab__tg amb-cab__tg--' + tgState }, [
        el('h3', { class: 'amb-cab__h3', text: T.tg_title }),
        tg,
        el('div', { class: 'profile-divider' }),
        name
      ]);
    }

    function perk(state, title, detail, extra) {
      var icon = { done: ICON.check, waiting: ICON.clock, info: ICON.dot, locked: ICON.lock, upcoming: ICON.clock }[state] || ICON.dot;
      return el('li', { class: 'amb-cab__perk amb-cab__perk--' + state }, [
        el('span', { class: 'amb-cab__perk-icon', 'aria-hidden': 'true', html: icon }),
        el('span', { class: 'amb-cab__perk-text' }, [
          el('span', { class: 'amb-cab__perk-title', text: title }),
          detail ? el('span', { class: 'amb-cab__perk-detail', text: detail }) : null
        ]),
        extra || null
      ]);
    }

    function nameSwitch() {
      var input = el('input', { type: 'checkbox', role: 'switch', class: 'amb-cab__switch-input', 'aria-label': T.perk_name });
      input.checked = Boolean(a.show_name_on_site);
      input.addEventListener('change', function () {
        input.disabled = true;
        call({ action: 'ambassador', show_name: input.checked }).then(function (data) { redraw(data); flash(T.saved); }, function () {
          input.checked = !input.checked; input.disabled = false; flash(T.save_failed, true);
        });
      });
      return el('label', { class: 'amb-cab__switch' }, [input, el('span', { class: 'amb-cab__switch-track', 'aria-hidden': 'true' })]);
    }

    function perksCard() {
      var level = Math.max(1, tier);
      var tshirtDue = a.tshirt_due_at && new Date(a.tshirt_due_at) > new Date();
      var level1 = [
        perk(a.telegram_invited_at ? 'done' : 'waiting', T.perk_channel,
          a.telegram_invited_at ? fill(T.state_done, { date: date(a.telegram_invited_at) }) : (a.telegram ? T.state_waiting : T.state_needs_tg)),
        perk('info', T.perk_first, T.state_always),
        perk(a.bracelet_given_at ? 'done' : 'waiting', T.perk_bracelet,
          a.bracelet_given_at ? fill(T.state_done, { date: date(a.bracelet_given_at) }) : T.state_at_event),
        perk('info', T.perk_name, a.show_name_on_site ? T.state_on : T.state_off, nameSwitch())
      ];
      var level2 = [
        perk('info', T.perk_entry, a.entries ? fill(T.state_entries, { n: a.entries }) : T.state_always),
        perk('info', T.perk_draw, T.state_team),
        perk(a.tshirt_given_at ? 'done' : (tshirtDue ? 'upcoming' : 'waiting'), T.perk_tshirt,
          a.tshirt_given_at ? fill(T.state_done, { date: date(a.tshirt_given_at) })
            : (tshirtDue ? fill(T.state_from, { date: date(a.tshirt_due_at) }) : T.state_at_event))
      ];
      var level3 = [
        perk('info', T.perk_extra, T.state_always),
        perk('info', T.perk_letter, T.state_team),
        perk('info', T.perk_party, T.state_team)
      ];
      function group(n, list) {
        var locked = level < n;
        return el('div', { class: 'amb-cab__perk-group' + (locked ? ' is-locked' : '') }, [
          el('p', { class: 'amb-cab__eyebrow', text: T.tier_names[n] }),
          el('ul', { class: 'amb-cab__perks', role: 'list' }, locked
            ? list.map(function (li) { return perk('locked', li.querySelector('.amb-cab__perk-title').textContent, null); })
            : list)
        ]);
      }
      return el('article', { class: 'amb-cab__card amb-cab__perks-card' }, [
        el('h3', { class: 'amb-cab__h3', text: T.perks_title }),
        group(1, level1), group(2, level2), group(3, level3)
      ]);
    }

    function manageCard() {
      var history = (a.payments || []).map(function (p) {
        var label = p.refunded ? T.history_refunded : (p.kind === 'renewal' ? T.history_renewal : T.history_first);
        return el('li', { class: 'profile-history__row' + (p.refunded ? ' is-refunded' : '') }, [
          el('span', { class: 'profile-history__date', text: date(p.paid_at) }),
          el('span', { class: 'profile-history__what' }, [
            el('span', { text: label }),
            p.tier ? el('span', { class: 'profile-history__tier', text: T.tier_names[p.tier] }) : null
          ]),
          el('span', { class: 'profile-history__sum', text: Math.round(Number(p.amount)) + ' ' + cfg.currency })
        ]);
      });
      // One main action; the rest as an even list, cancel last and quieter — but in
      // plain sight: nobody should have to hunt for how to leave.
      function row(label, extra) {
        return el('li', null, el('a', { class: 'profile-manage__row' + (extra || ''), href: cfg.portalUrl }, [
          el('span', { text: label }),
          el('span', { class: 'profile-manage__chevron', 'aria-hidden': 'true', html: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"></polyline></svg>' })
        ]));
      }
      // Our own buttons on Appstle's contract (assets/ambassador-manage.js); a paused
      // or cancelled contract also shows on the tier card. Without that script, the portal links.
      var live = window.GalasAmbassadorManage && window.GalasAmbassadorManage.controls(api, function (contract) {
        var chip = body.querySelector('.amb-cab__tier .amb-cab__chip');
        var says = { paused: ['warn', T.manage_paused], cancelled: ['off', T.manage_cancelled_chip] }[contract.status];
        if (chip && says) { chip.className = 'amb-cab__chip amb-cab__chip--' + says[0]; chip.textContent = says[1]; }
      });
      return el('article', { class: 'amb-cab__card amb-cab__manage' }, [
        el('h3', { class: 'amb-cab__h3', text: T.manage_title }),
        el('p', { class: 'amb-cab__muted', text: T.manage_body }),
        live || el('a', { class: 'button button--primary profile-manage__main', href: cfg.portalUrl },
          el('span', { class: 'button__label', text: T.manage_change })),
        live ? null : el('ul', { class: 'profile-manage', role: 'list' }, [
          row(T.manage_pause), row(T.manage_card), row(T.manage_cancel, ' profile-manage__row--quiet')
        ]),
        history.length ? el('div', { class: 'profile-history' }, [
          el('p', { class: 'amb-cab__eyebrow', text: T.history_title }),
          el('ul', { class: 'profile-history__list', role: 'list' }, history)
        ]) : null
      ]);
    }

    // Two columns that each stack, so neither leaves a hole: the card, payment and tier,
    // Telegram on the left; the figures and the perks on the right. On a phone they run
    // one after the other, with the figures straight under the tier card (profile.css).
    body.appendChild(el('div', { class: 'profile-amb' }, [
      el('div', { class: 'profile-amb__col' }, tierCard().concat([manageCard(), detailsCard()])),
      el('div', { class: 'profile-amb__col' }, [statsCard(a), perksCard()])
    ]));
  });

  /* ── Мої квитки ─────────────────────────────────────────────────────── */
  // One sheet per ticket: the QR to show at the door, then the copies to keep
  // (PDF, Apple Wallet, Google Wallet). The list itself stays one quiet row a seat.
  var sheet;
  function showTicket(t, isPast) {
    if (!sheet) {
      sheet = el('dialog', { class: 'profile-qr', 'aria-labelledby': 'profile-qr-title' });
      sheet.addEventListener('click', function (e) { if (e.target === sheet) sheet.close(); });
      document.body.appendChild(sheet);
    }
    clear(sheet);
    var links = t.links || {};
    var qr = t.qr && !isPast ? t.qr : null;
    var size = qr ? qr.size + 8 : 0;
    function link(href, icon, label, blank) {
      return href ? el('a', { class: 'profile-qr__link', href: href, target: blank ? '_blank' : null, rel: blank ? 'noopener' : null }, [
        el('span', { 'aria-hidden': 'true', html: icon }), label
      ]) : null;
    }
    var keep = [
      link(links.pdf, ICON.doc, T.ticket_pdf, true),
      link(links.apple, ICON.wallet, T.ticket_apple, false),
      link(links.google, ICON.wallet, T.ticket_google, true)
    ].filter(Boolean);
    sheet.appendChild(el('div', { class: 'profile-qr__inner' }, [
      el('button', { type: 'button', class: 'profile-qr__close', 'aria-label': T.close, html: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>', onclick: function () { sheet.close(); } }),
      el('p', { id: 'profile-qr-title', class: 'profile-qr__title', text: t.event.title }),
      el('p', { class: 'profile-qr__sub', text: [t.ticket_type, t.attendee_name].filter(Boolean).join(' · ') }),
      qr ? el('div', { class: 'profile-qr__code', html: '<svg viewBox="-4 -4 ' + size + ' ' + size + '" shape-rendering="crispEdges" role="img" aria-label="QR ' + t.code + '"><rect x="-4" y="-4" width="' + size + '" height="' + size + '" fill="#fff"/><path fill="#000" d="' + qr.d + '"/></svg>' }) : null,
      el('p', { class: 'profile-qr__codeline', text: t.code }),
      qr ? el('p', { class: 'amb-cab__muted', text: T.ticket_qr_hint }) : null,
      keep.length ? el('div', { class: 'profile-qr__links' + (keep.length === 3 ? ' is-three' : '') }, keep) : null
    ]));
    sheet.showModal();
  }

  function eventWhen(ev) {
    try {
      var tz = ev.timezone || 'Europe/Warsaw';
      var when = new Date(ev.starts_at);
      var day = new Intl.DateTimeFormat(locale, Object.assign({ timeZone: tz }, NUMERIC_DATE)).format(when);
      var time = new Intl.DateTimeFormat(locale, { hour: '2-digit', minute: '2-digit', timeZone: tz }).format(when);
      return day + ', ' + time;
    } catch (e) { return date(ev.starts_at); }
  }

  panel('tickets', function (body, list) {
    clear(body);
    list = list || [];
    if (!list.length) {
      body.appendChild(el('div', { class: 'amb-cab__card profile-empty' }, [
        el('span', { class: 'profile-empty__icon', 'aria-hidden': 'true', html: ICON.qr }),
        el('div', { class: 'profile-empty__text' }, [
          el('h3', { class: 'amb-cab__h3', text: T.tickets_none_title }),
          el('p', { class: 'amb-cab__muted', text: fill(T.tickets_none_body, { email: cfg.email }) })
        ]),
        el('a', { class: 'button button--primary', href: cfg.nextEventUrl },
          el('span', { class: 'button__label', text: T.tickets_cta }))
      ]));
      return;
    }

    // One card per event, seats inside; upcoming (until a day and a half after the start) first.
    var events = [];
    var byEvent = {};
    list.forEach(function (t) {
      var key = t.event.slug;
      if (!byEvent[key]) { byEvent[key] = { event: t.event, seats: [] }; events.push(byEvent[key]); }
      byEvent[key].seats.push(t);
    });
    var cutoff = Date.now() - 36 * 3600 * 1000;
    var upcoming = events.filter(function (g) { return new Date(g.event.starts_at).getTime() >= cutoff; }).reverse();
    var past = events.filter(function (g) { return new Date(g.event.starts_at).getTime() < cutoff; });

    function seatRow(t, isPast) {
      // A seat never scanned at an event that is over is not «valid» in any useful sense.
      var status = isPast && t.status === 'valid' ? 'past' : t.status;
      var who = t.attendee_name || (t.for_email ? fill(T.ticket_for, { email: t.for_email }) : null);
      var hasQr = t.qr && !isPast;
      var openable = hasQr || t.links;
      function open() { showTicket(t, isPast); }
      return el('li', { class: 'profile-seat profile-seat--' + status + (openable ? ' is-openable' : ''), onclick: openable ? function (e) {
        if (!e.target.closest('button')) open();
      } : null }, [
        el('div', { class: 'profile-seat__main' }, [
          el('p', { class: 'profile-seat__type', text: t.ticket_type }),
          el('p', { class: 'profile-seat__meta' }, [
            el('span', { class: 'profile-chip profile-chip--' + status, text: T['ticket_status_' + status] || status }),
            el('span', { class: 'profile-seat__code', text: t.code })
          ]),
          who || t.order_number ? el('p', { class: 'profile-seat__order', text: [who, t.order_number ? fill(T.ticket_order, { n: t.order_number }) : null].filter(Boolean).join(' · ') }) : null
        ]),
        openable ? el('button', {
          type: 'button',
          class: 'profile-seat__open' + (hasQr ? ' is-qr' : ''),
          'aria-label': (hasQr ? T.ticket_qr : T.ticket_pdf) + ' · ' + t.code,
          html: hasQr ? ICON.qr : ICON.doc,
          onclick: open
        }) : null
      ]);
    }

    // The event's own art, as on the badge shelf: the card reads as one event at a glance.
    function eventArt(g) {
      var catalog = (cfg.badges && cfg.badges.catalog) || [];
      var entry = catalog.filter(function (e) { return (e.db || []).indexOf(g.event.slug) !== -1; })[0];
      if (!entry || !window.GalasBadges) {
        return el('span', { class: 'profile-event__art is-plain', 'aria-hidden': 'true', html: ICON.sparkle });
      }
      var codes = g.seats.map(function (t) { return t.code; }).filter(Boolean).sort();
      return el('span', { class: 'profile-event__art', 'aria-hidden': 'true' },
        face({ art: entry.art, seed: codes[0] || entry.key, artTitle: entry.artTitle, artNumber: entry.artNumber }, 'colour'));
    }

    // One card per event: the art and the event on top, its seats in a tray below, so a
    // seat never reads as an event of its own.
    function eventCard(g, isPast) {
      return el('article', { class: 'amb-cab__card profile-event' + (isPast ? ' is-past' : '') }, [
        el('header', { class: 'profile-event__head' }, [
          eventArt(g),
          el('div', { class: 'profile-event__text' }, [
            el('h3', { class: 'profile-event__title', text: g.event.title }),
            el('p', { class: 'profile-event__when', text: [eventWhen(g.event), g.event.venue].filter(Boolean).join(' · ') }),
            // The festival's own hours, as the team typed them (one line per day).
            g.event.schedule ? el('p', { class: 'profile-event__schedule', text: g.event.schedule }) : null
          ])
        ]),
        el('ul', { class: 'profile-seats', role: 'list' }, g.seats.map(function (t) { return seatRow(t, isPast); }))
      ]);
    }

    if (upcoming.length) {
      body.appendChild(el('p', { class: 'amb-cab__eyebrow profile-group-label', text: T.tickets_upcoming }));
      upcoming.forEach(function (g) { body.appendChild(eventCard(g, false)); });
    }
    if (past.length) {
      var details = el('details', { class: 'profile-past' }, [
        el('summary', { class: 'profile-past__summary' }, [T.tickets_past, el('span', { class: 'profile-past__n', text: String(past.length) })])
      ]);
      if (!upcoming.length) details.open = true;
      past.forEach(function (g) { details.appendChild(eventCard(g, true)); });
      body.appendChild(details);
    }
  });

  /* ── Бейджі ─────────────────────────────────────────────────────────── */
  // Every badge that can exist is the catalog Liquid prints (snippets/badge-catalog,
  // oldest first, with the keys this customer owns through Shopify orders). The
  // DB's tickets say which of the DB events are held. A ticket earns the badge the
  // moment it is bought: the purchase already says «бейдж зараховано», and a card
  // still faded until the door scanned it read as a promise broken. So a badge is:
  //   open    held (a live ticket), bought before tickets lived in the DB, or granted by hand
  //   locked  not held — the same art as an outline
  // The panel shows the four most recent held ones and «Подивитися всі»; the
  // gallery (/pages/profile?view=badges) shows the tiers and the whole catalog.
  // Faces are drawn by assets/profile-badges.js. No ticket codes on any card.
  var SPARKLE_D = 'M12 2.5c.7 5.2 4.3 8.8 9.5 9.5-5.2.7-8.8 4.3-9.5 9.5-.7-5.2-4.3-8.8-9.5-9.5 5.2-.7 8.8-4.3 9.5-9.5z';
  var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  var badgeSeq = 0;

  function badgeModel(data) {
    var catalog = (cfg.badges && cfg.badges.catalog) || [];
    var owned = (cfg.badges && cfg.badges.owned) || [];
    var groups = {};
    ((data && data.tickets) || []).forEach(function (t) {
      if (!t || !t.event || t.status === 'refunded' || t.status === 'void') return;
      var g = groups[t.event.slug] || (groups[t.event.slug] = { event: t.event, codes: [] });
      if (t.code) g.codes.push(t.code);
    });
    var used = {};
    var list = catalog.map(function (e, i) {
      var hits = (e.db || []).map(function (slug) { used[slug] = true; return groups[slug]; }).filter(Boolean);
      var codes = [].concat.apply([], hits.map(function (g) { return g.codes; })).sort();
      // `owned`: bought before tickets lived in the DB, or granted by hand
      // (customer metafield galas.badges) — either way it was attended.
      var state = owned.indexOf(e.key) !== -1 || hits.length ? 'open' : 'locked';
      return {
        order: i, key: e.key, title: e.title, start: e.start, end: e.end, art: e.art,
        artTitle: e.artTitle, artNumber: e.artNumber, group: e.group || 'galas', state: state,
        seed: state === 'locked' ? e.key : (codes[0] || e.key)
      };
    });
    // One of our own DB events the catalog does not list yet still earns its
    // card; a partner event (any other slug) waits for its catalog row.
    Object.keys(groups).forEach(function (slug) {
      if (used[slug] || slug.indexOf('galas-') !== 0) return;
      var g = groups[slug];
      var num = /#\s?(\d+)/.exec(g.event.title || '');
      list.push({
        order: catalog.length, key: slug, title: g.event.title, start: (g.event.starts_at || '').slice(0, 10), end: '',
        art: 'other', artTitle: g.event.title, artNumber: num ? '#' + num[1] : '', group: 'galas',
        state: 'open', seed: g.codes.sort()[0] || slug
      });
    });
    // The catalog's own order (Streetball #1, #10, #11, #12 — the user's choice), then any
    // DB event the catalog does not list yet, by date.
    list.sort(function (x, y) { return (x.order - y.order) || String(x.start).localeCompare(String(y.start)); });
    return list;
  }

  // 01–02.08.2026, or 16.08.2026: a badge's days without a timezone to trip on.
  function days(start, end) {
    var a = String(start || '').split('-');
    if (a.length !== 3) return '';
    var b = String(end || '').split('-');
    if (b.length !== 3 || end === start) return a[2] + '.' + a[1] + '.' + a[0];
    if (a[1] === b[1] && a[0] === b[0]) return a[2] + '–' + b[2] + '.' + a[1] + '.' + a[0];
    return a[2] + '.' + a[1] + '–' + b[2] + '.' + b[1] + '.' + b[0];
  }

  function face(b, variant) {
    var canvas = el('canvas', { class: 'badge-card__canvas', width: '358', height: '448', 'aria-hidden': 'true' });
    if (window.GalasBadges) {
      window.GalasBadges.drawFace(canvas, { art: b.art, seed: b.seed, title: b.artTitle, number: b.artNumber, variant: variant });
    }
    return canvas;
  }

  function badgeCard(b) {
    if (b.state === 'locked') {
      return el('div', {
        class: 'badge-card is-locked', role: 'img',
        'aria-label': b.title + ' · ' + T.badges_locked,
        title: fill(T.badges_locked_hint, { event: b.title })
      }, el('span', { class: 'badge-card__face badge-card__face--front' }, el('span', { class: 'badge-card__art' }, face(b, 'outline'))));
    }
    var id = 'badge-back-' + (++badgeSeq);
    var bars = [1, 2, 3, 4, 5].map(function () { return el('span', { class: 'badge-card__bar' }); });
    var btn = el('button', {
      type: 'button',
      class: 'badge-card is-admitted',
      'aria-pressed': 'false',
      'aria-label': b.title + ' · ' + T.badges_flip,
      'aria-describedby': id,
      'data-holo': ''
    }, el('span', { class: 'badge-card__flip' }, [
      el('span', { class: 'badge-card__face badge-card__face--front' }, [
        el('span', { class: 'badge-card__art' }, [
          face(b, 'colour'),
          el('span', { class: 'holo__sheen', 'aria-hidden': 'true' }),
          el('span', { class: 'holo__glare', 'aria-hidden': 'true' })
        ])
      ]),
      el('span', { class: 'badge-card__face badge-card__face--back' }, [
        el('span', { class: 'badge-card__back-mark', 'aria-hidden': 'true', html: ICON.sparkle }),
        el('span', { class: 'badge-card__back-title', text: T.badges_back_title }),
        el('span', { id: id, class: 'badge-card__back-body', text: T.badges_back_body }),
        el('span', { class: 'badge-card__bars', 'aria-hidden': 'true' }, bars)
      ])
    ]));
    // One turn at a time: a tap during the turn is ignored rather than
    // reversing it halfway.
    var flip = btn.firstChild;
    var settle = 0;
    function done() { clearTimeout(settle); btn.classList.remove('is-flipping'); }
    flip.addEventListener('transitionend', function (e) { if (e.target === flip && e.propertyName === 'transform') done(); });
    btn.addEventListener('click', function () {
      if (btn.classList.contains('is-flipping')) return;
      btn.classList.add('is-flipping');
      settle = setTimeout(done, 900);
      btn.setAttribute('aria-pressed', btn.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
    });
    return btn;
  }

  // Badges that arrived since the profile was last opened (assets/badge-moment.js).
  var freshBadges = (window.GalasBadgeMoment && window.GalasBadgeMoment.fresh) || [];

  function badgeSlot(b) {
    var isNew = b.state !== 'locked' && freshBadges.indexOf(b.key) !== -1;
    return el('li', { class: 'badge-slot badge-slot--' + b.state + (isNew ? ' is-new' : '') }, [
      badgeCard(b),
      el('p', { class: 'badge-slot__title' }, [
        isNew ? el('span', { class: 'badge-slot__new', text: T.badges_fresh }) : null,
        b.title
      ]),
      el('p', { class: 'badge-slot__when', text: [days(b.start, b.end), b.state === 'locked' ? T.badges_locked : null].filter(Boolean).join(' · ') })
    ]);
  }

  // A cell the size of a card, drawn as an outline: «Подивитися всі», «Скоро».
  function outlineCell(tag, props, mark, title, body) {
    return el('li', { class: 'badge-slot' }, el(tag, Object.assign({ class: 'badge-card badge-cell' }, props), [
      el('span', { class: 'badge-cell__mark', 'aria-hidden': 'true', html: mark }),
      el('span', { class: 'badge-cell__title', text: title }),
      body ? el('span', { class: 'badge-cell__body', text: body }) : null
    ]));
  }

  function tierCoin(n, earned) {
    var spots = {
      1: [[60, 60, 2.7]],
      2: [[45, 50, 1.75], [76, 72, 1.75]],
      3: [[60, 38, 1.4], [38, 74, 1.4], [82, 74, 1.4]]
    }[n];
    var stars = spots.map(function (p) {
      return '<path class="badge-tier__star" transform="translate(' + p[0] + ' ' + p[1] + ') scale(' + p[2] + ') translate(-12 -12)" d="' + SPARKLE_D + '"/>';
    }).join('');
    var name = T.tier_names[n];
    var label = fill(T.level, { n: n }) + ' · ' + name + ' · ' + (earned ? T.badges_earned : T.badges_locked);
    return el('li', { class: 'badge-tier badge-tier--' + n + (earned ? ' is-earned' : ' is-locked') }, [
      el('span', { class: 'badge-tier__coin', role: 'img', 'aria-label': label, 'data-holo': earned ? '' : null }, [
        el('span', { class: 'badge-tier__art', html: '<svg viewBox="0 0 120 120" aria-hidden="true"><circle class="badge-tier__disc" cx="60" cy="60" r="56"/><circle class="badge-tier__ring" cx="60" cy="60" r="48"/>' + stars + '</svg>' }),
        earned ? el('span', { class: 'holo__sheen', 'aria-hidden': 'true' }) : null,
        earned ? el('span', { class: 'holo__glare', 'aria-hidden': 'true' }) : null
      ]),
      el('p', { class: 'badge-tier__name', 'aria-hidden': 'true', text: name }),
      el('p', { class: 'badge-tier__state', 'aria-hidden': 'true', text: earned ? fill(T.level, { n: n }) : T.badges_locked })
    ]);
  }

  function holoAll(body) {
    if (!window.GalasBadges) return;
    Array.prototype.forEach.call(body.querySelectorAll('[data-holo]'), window.GalasBadges.holo);
  }

  // «Мій профіль»: the last four badges you hold, in catalog order, and the way to the rest.
  panel('badges', function (body, data) {
    clear(body);
    var held = badgeModel(data).filter(function (b) { return b.state !== 'locked'; }).slice(-4);
    var more = outlineCell('a', { href: cfg.galleryUrl }, ARROW, T.badges_see_all, null);
    if (!held.length) {
      body.appendChild(el('div', { class: 'amb-cab__card profile-empty badges__empty' }, [
        el('span', { class: 'profile-empty__icon', 'aria-hidden': 'true', html: ICON.sparkle }),
        el('div', { class: 'profile-empty__text' }, el('p', { class: 'amb-cab__muted', text: T.badges_empty })),
        el('a', { class: 'button button--primary', href: cfg.nextEventUrl }, el('span', { class: 'button__label', text: T.tickets_cta }))
      ]));
    } else {
      body.appendChild(el('p', { class: 'amb-cab__muted badges__hint', text: T.badges_collection_hint }));
    }
    body.appendChild(el('ul', { class: 'badges__grid', role: 'list' }, held.map(badgeSlot).concat(more)));
    holoAll(body);
  }, function (data) { return data; });

  // The gallery: the tiers, then every Galas badge and what is coming, then partner events
  // (one badge per tour, not per city).
  panel('gallery', function (body, data) {
    clear(body);
    var a = (data && data.ambassador) || {};
    var max = a.found ? Math.max(Number(a.max_tier) || 0, Number(a.tier) || 0) : 0;
    body.appendChild(el('section', { class: 'badges__group' }, [
      el('h2', { class: 'amb-cab__h3 badges__h', text: T.badges_amb_title }),
      el('p', { class: 'amb-cab__muted badges__hint', text: a.found ? T.badges_amb_hint : T.badges_amb_none }),
      el('ul', { class: 'badges__tiers', role: 'list' }, [1, 2, 3].map(function (n) { return tierCoin(n, n <= max); })),
      a.found ? null : el('a', { class: 'button button--cta badges__amb-cta', href: cfg.tiersUrl }, el('span', { class: 'button__label', text: T.none_cta }))
    ]));
    var soon = outlineCell('div', { role: 'note' }, '<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-width="1" stroke-linejoin="round" d="' + SPARKLE_D + '"/><text x="12" y="14.6" text-anchor="middle" font-size="7" fill="currentColor">?</text></svg>', T.badges_soon_title, T.badges_soon_body);
    var all = badgeModel(data);
    var partner = all.filter(function (b) { return b.group === 'partner'; });
    body.appendChild(el('section', { class: 'badges__group' }, [
      el('h2', { class: 'amb-cab__h3 badges__h', text: T.badges_events_title }),
      el('ul', { class: 'badges__grid badges__grid--gallery', role: 'list' },
        all.filter(function (b) { return b.group !== 'partner'; }).map(badgeSlot).concat(soon))
    ]));
    if (partner.length) {
      body.appendChild(el('section', { class: 'badges__group' }, [
        el('h2', { class: 'amb-cab__h3 badges__h', text: T.badges_partner_title }),
        el('p', { class: 'amb-cab__muted badges__hint', text: T.badges_partner_hint }),
        el('ul', { class: 'badges__grid badges__grid--gallery', role: 'list' }, partner.map(badgeSlot))
      ]));
    }
    holoAll(body);
  }, function (data) { return data; });

  /* ── boot ───────────────────────────────────────────────────────────── */
  function bodies() {
    return Array.prototype.filter.call(root.querySelectorAll('[data-profile-panel]'), function (p) {
      return panels[p.getAttribute('data-profile-panel')];
    });
  }

  function renderError() {
    bodies().forEach(function (p) {
      var body = p.querySelector('[data-profile-body]');
      clear(body);
      body.appendChild(el('div', { class: 'amb-cab__card profile-empty' }, [
        el('div', { class: 'profile-empty__text' }, [
          el('h3', { class: 'amb-cab__h3', text: T.error_title }),
          el('p', { class: 'amb-cab__muted', text: T.error_body })
        ]),
        button(T.retry, { onclick: load })
      ]));
    });
  }

  // The last answer, kept for this tab only (sessionStorage) and without the
  // ticket QR codes and links, is drawn at once on the next visit, so the page
  // is not empty while the `profile` function answers; the fresh answer then
  // replaces it.
  var CACHE = 'galas:profile:' + (cfg.email || '');
  function cached() {
    try { return JSON.parse(sessionStorage.getItem(CACHE) || 'null'); } catch (e) { return null; }
  }
  function keep(data) {
    try {
      var copy = Object.assign({}, data, {
        tickets: (data.tickets || []).map(function (t) { return Object.assign({}, t, { qr: null, links: null }); })
      });
      sessionStorage.setItem(CACHE, JSON.stringify(copy));
    } catch (e) { /* private mode or full: just no head start */ }
  }

  function draw(waiting, data) {
    answer = data;
    waiting.forEach(function (p) {
      var type = p.getAttribute('data-profile-panel');
      panels[type](p.querySelector('[data-profile-body]'), pickers[type] ? pickers[type](data) : data[type], api);
    });
  }

  function load() {
    var waiting = bodies();
    if (!waiting.length) return;
    var early = cached();
    if (early) draw(waiting, early);
    var scrolled = false;
    function toHash() {
      // Arriving from a link to #tickets: the panel has grown since the browser scrolled.
      // #ambassador is the first panel, so old links to it (emails, the former cabinet)
      // stay at the top instead of jumping past the greeting.
      if (scrolled || !location.hash || location.hash === '#ambassador') return;
      scrolled = true;
      var target = document.getElementById(location.hash.slice(1));
      if (target) target.scrollIntoView();
    }
    if (early) toHash();
    call().then(function (data) {
      keep(data);
      draw(waiting, data);
      toHash();
    }, function (error) { if (!early) renderError(error); });
  }

  load();
})();
